import { isAxiosError } from "axios";
import {
  getApiErrorMessage,
  isFetchBaseQueryError,
} from "../../../api/helpers/errors.js";

/**
 * The HTTP status a refused invite came back with. The bulk form posts with
 * axios while a row action goes through RTK Query, so the two failures carry
 * the status in different places.
 */
function findErrorStatus(error: unknown): number | undefined {
  if (isAxiosError(error)) {
    return error.response?.status;
  }
  if (isFetchBaseQueryError(error) && typeof error.status === "number") {
    return error.status;
  }
  return undefined;
}

/** The message to show for an invite the API refused. */
export function buildInviteFailureMessage(error: unknown): string {
  // The daily invite cap answers with a hand-rolled body that carries no
  // `message`, unlike every other refusal.
  if (findErrorStatus(error) === 429) {
    return "This company has reached its daily invitation limit. Try again tomorrow.";
  }
  return getApiErrorMessage(error, "Failed to send invitation");
}
